<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 28/10/2021
  -->

<template>
	<el-tag
		class="qw-tag"
		:disableTransitions="true"
		:closable="closable"
		:style="{'borderColor' : tag.borderColor(), 'color' : tag.textColor()}"
		:color="tag.backgroundColor()"
		v-bind="listenersComputed"
	>
		<slot name="default">
			{{ titleEllipsed }}
		</slot>
	</el-tag>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import TagItem from "@shared/Tags/TagItem";
import {ellipsisString} from "@/utils/helpers";

export default {
	name: "QwTag",
	extends: BaseComponent,
	inheritAttrs: false,

	props: {
		tag: {TagItem, required: true},
		closable: {Boolean, default: true},
		tagTitleMaxLength: {Number, default: 20},
	},

	computed: {
		titleEllipsed() {
			return ellipsisString(this.tag.title, this.tagTitleMaxLength, true)
		},

		listenersComputed(){
			let {onClose, ...rest} = this.$attrs

			let attrs = {
				...rest,
				onClose: () => onClose ? onClose(this.tag) : null
			}
			// console.log("qwtag attrs = ", attrs)
			return attrs
		}
	},
}
</script>

<style lang="scss">

.qw-tag {
	.el-tag__close {
		color: inherit;
	}
	display: inline-flex;
}

</style>
